import { Component, OnInit } from '@angular/core';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';



@Component({
  selector: 'app-vincular-uri-alfresco-dialog',
  templateUrl: './vincular-uri-alfresco-dialog.component.html',
  styleUrls: ['./vincular-uri-alfresco-dialog.component.scss']
})
export class VincularUriAlfrescoDialogComponent implements OnInit {


  uris : any [];
  selected : any;

  constructor(public service : ConfigurarPastaServiceService) { 

    service.getURIsAlfresco().subscribe(dados => {
      this.uris = dados;
    })
  }

  ngOnInit() {
  }

  salvar(){
    console.log(this.selected)
  }

}



// WEBPACK FOOTER //
// /app/src/app/vincular-uri-alfresco-dialog/vincular-uri-alfresco-dialog.component.ts